import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import { loginService } from "@/services/login.service";
// import authentication from "../authentication";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/login",
    name: "LogIn",
    component: () => import(/* webpackChunkName: "log" */ "../views/LogIn.vue")
  },
  {
    path: "/pss",
    name: "PasswordRequest",
    component: () => import(/* webpackChunkName: "log" */ "../views/PasswordRequest.vue")
  },
  {
    path: "/cpss",
    name: "PasswordChange",
    component: () => import(/* webpackChunkName: "log" */ "../views/PasswordChange.vue")
  },
  {
    path: "/homepreautorizados",
    name: "Preautorizados",
    component: () => import(/* webpackChunkName: "home-preautorizados" */ "../views/HomePreautorizados.vue")
  },
  {
    path: "/profiling",
    name: "Profiling",
    component: () => import(/* webpackChunkName: "profiling" */ "../views/Profiling.vue")
  },
  {
    path: "/imss",
    name: "Imss",
    component: () => import(/* webpackChunkName: "profiling" */ "../views/ProfilingImss.vue")
  },
  {
    path: "/homeimss",
    name: "HomeImss",
    component: () => import(/* webpackChunkName: "profiling" */ "../views/HomeImss.vue")
  },
  {
    path: "/offerimss",
    name: "OfferImss",
    component: () => import(/* webpackChunkName: "profiling" */ "../views/OfferImss.vue")
  },
  {
    path: "/offer",
    name: "Offer",
    component: () => import(/* webpackChunkName: "offer" */ "../views/Offer.vue")
  },
  {
    path: "/ob",
    name: "OfferBranch",
    component: () => import(/* webpackChunkName: "offer-branch" */ "../views/OfferBranch.vue")
  },
  {
    path: "/oe",
    name: "OfferExpress",
    component: () => import(/* webpackChunkName: "offer-express" */ "../views/OfferExpress.vue")
  },
  {
    path: "/op",
    name: "OfferPreautorizado",
    component: () => import(/* webpackChunkName: "offer-express" */ "../views/OfferPreautorizado.vue")
  },
  {
    path: "/cb",
    name: "CreditBureau",
    component: () => import(/* webpackChunkName: "credit-bureau" */ "../views/CreditBureau.vue")
  },
  // {
  //   path: "/documentation",
  //   name: "Documentation",
  //   component: () => import(/* webpackChunkName: "documentation" */ "../views/Documentation.vue")
  // },
  // {
  //   path: "/attestation",
  //   name: "Attestation",
  //   component: () => import(/* webpackChunkName: "attestation" */ "../views/Attestation.vue")
  // },
  // {
  //   path: "/devt",
  //   name: "DebtKnsurance",
  //   component: () => import(/* webpackChunkName: "attestation" */ "../views/DebtInsurance.vue")
  // },
  // {
  //   path: "/address",
  //   name: "Address",
  //   component: () => import(/* webpackChunkName: "attestation" */ "../views/Address.vue")
  // },
  {
    path: "/thanks",
    name: "Thanks",
    component: () => import(/* webpackChunkName: "thanks" */ "../views/Thanks.vue")
  },
  // {
  //   path: "/terms-conditions",
  //   name: "Terms",
  //   component: () => import(/* webpackChunkName: "terms-conditions" */ "../views/Terms.vue")
  // },
  {
    path: "/404",
    name: "NotFound",
    component: () => import(/* webpackChunkName: "notfound" */ "../views/404.vue")
  },
  // Redirect any unmatched routes to the 404 page. This may require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404"
  },
  {
    path: "/declined",
    name: "DeclinedOffer",
    component: () => import("../views/DeclinedOffer.vue")
  }
];

if (process.env.NODE_ENV === "development") {
  routes.push(
    ...[
      {
        path: "/about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
      },
      {
        path: "/dev/colors",
        name: "Color Palette",
        component: () => import(/* webpackChunkName: "dev-colors" */ "../views/Colors.vue")
      },
      {
        path: "/dev/controls",
        name: "Controls",
        component: () => import(/* webpackChunkName: "dev-controls" */ "../views/Controls.vue")
      }
      // {
      //   path: "/dev/webcam",
      //   name: "Webcam",
      //   component: () => import(/* webpackChunkName: "dev-webcam" */ "../views/Webcam.vue")
      // }
    ]
  );
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  // Avoids going back to offer when the Traditional offer or Express Offer path was selected
  if (to.name === "PasswordChange") {
    next();
  } else if (to.name === "PasswordRequest") {
    if (from.name !== "LogIn") {
      next({ path: "/login" });
    } else {
      next();
    }
  } else if (loginService.IsAuthenticated()) {
    if (to.name === "LogIn") {
      next({ path: "/" });
    } else if ((from.name === "OfferBranch" || from.name === "OfferExpress") && to.name == "Offer") {
      next({ path: "/", replace: true });
    } else {
      next();
    }
  } else {
    if (await loginService.InitSession()) {
      if (to.name === "LogIn") {
        next({ path: "/" });
      } else if ((from.name === "OfferBranch" || from.name === "OfferExpress") && to.name == "Offer") {
        next({ path: "/", replace: true });
      } else {
        next();
      }
    } else {
      if (to.name !== "LogIn") {
        next({ path: "/login" });
      } else {
        next();
      }
    }
  }
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuthentication)) {
//     if (authentication.isAuthenticated()) {
//       if ((from.name === "OfferBranch" || from.name === "OfferExpress") && to.name == "Offer") {
//         next({ path: "/", replace: true });
//       } else {
//         next();
//       }
//     } else {
//       authentication.signIn();
//     }
//   } else {
//     next();
//   }
// });

export default router;
